import script from "./ProductCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCourse.vue?vue&type=script&setup=true&lang=js"

import "./ProductCourse.vue?vue&type=style&index=0&id=4bd2b4c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd2b4c4"]])

export default __exports__